/**
 * Copyright ©2023 Drivepoint
 */

import {Store} from "@bainbridge-growth/node-frontend";
import WebAppServerClient from "../clients/WebAppServerClient";
import State from "../state/State";
import {StateEvent} from "../state/StateEvent";

export default class ReportsStore extends Store {

  private _company?: any;
  private _loaded: boolean = false; // prevent reports from being loaded multiple times

  init(): void {
    this.loading = true;
    State.register("company", (event: StateEvent) => {
      this.value = [];
      this._company = event.value;
      this.refresh();
    });
  }

  async refresh(): Promise<void> {
    return this.action(async () => {
      if (!this._company || this._loaded) { return; }
      const results = await Promise.all([this._getDazzlerReports(), this._getOmniReports(), this._getHtmlReports()]);
      this.value = results.flat();
      this._loaded = true;
    });
  }

  private async _getDazzlerReports(): Promise<any[]> {
    return await WebAppServerClient.request(`/api/company/${this._company.id}/dazzler/reports`, "GET");
  }

  private async _getHtmlReports(): Promise<any[]> {
    let reports: any[] = [];
    try {
      reports = await WebAppServerClient.request(`/api/company/${this._company.id}/reportDefinitions`, "GET");
    } catch (error: any) {
      logger.warn(`could not load report definitions: ${error.message}`);
    }
    return reports
      .filter(report => report.status !== "archived")
      .map(report => ({...report, type: "html-report"}));
  }

  private async _getOmniReports(): Promise<any[]> {
    let reports: any[] = [];
    try {
      reports = await WebAppServerClient.request(`/api/company/${this._company.id}/omni`, "GET");
    } catch (error: any) {
      logger.warn(`could not load Omni reports: ${error.message}`);
    }
    return reports.map(report => ({...report, type: "omni"}));
  }

  async deleteMcpReport(reportId: string): Promise<void> {
    if (!this._company) { return; }
    await WebAppServerClient.requestNoContent(`/api/company/${this._company.id}/reportDefinitions/${reportId}`, "DELETE");
    this.value = (this.value ?? []).filter((report: any) => report.id !== reportId);
  }

}
